<template>
	<div>
		<right-panel :datas="connects" :items="connects" @onClose="onCloseForm" @onSubmit="onSubmitAddForm" ref="right-panel-add">
			<div slot="header">
				<translate>Add Team Member</translate>
			</div>
		</right-panel>
	</div>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
export default {
	name: 'TeamAddMember',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
		}
	},
	methods: {
		// 确定添加sshkey
		onSubmitAddForm() {
			let params = {
				data: {
					account: this.$refs['right-panel-add'].profileModel.account,
					name: this.$refs['right-panel-add'].profileModel.name,
				},
			}
			// params.data.is_admin = this.$refs['right-panel-add'].profileModel.is_admin === 'admin'
			switch (this.$refs['right-panel-add'].profileModel.is_admin) {
				case 'ordinary':
					params.data.is_admin = 0
					break
				case 'admin':
					params.data.is_admin = 1
					break
				case 'auditAdmin':
					params.data.is_admin = 2
					break
				case 'optAdmin':
					params.data.is_admin = 3
					break
				case 'safeAdmin':
					params.data.is_admin = 4
					break
			}
			this.$store
				.dispatch(STORE_CONST.TEAM.ADD, params)
				.then(() => {
					this.$notify({
						message: this.$gettext('Add Successfully!'),
						type: 'success',
					})
					this.$refs['right-panel-add'].onClose()
					this.$emit('callback')
				})
				.catch(() => {
					console.log('this.profileModel', this.$refs['right-panel-add'].profileModel)
					this.$refs['right-panel-add'].onSubmitErr()
				})
		},
		// 关闭添加成员
		onCloseForm() {
			this.connects = null
			this.$emit('onClosePanel')
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
					}, 300)
				} else {
					this.connects = this.items
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss"></style>



// WEBPACK FOOTER //
// team-add-member.vue?56569904